import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@material-ui/core";
import { useSetState } from "Helpers/Hooks";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import { CONSTRUCTION_RESULT } from "Stores/actionTypes";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";

const OptimizeProfile = () => {
  const { constructionResult } = useSelector((state) => ({
    constructionResult: state.construction.constructionResult,
  }));
  const dispatch = useDispatch();
  const [controls, setControls] = useSetState({
    branchLength: {
      type: "millimeter",
      value: 6000,
      validation: {
        required: true,
        isNumeric: true,
        min: 4000,
        max: 12000,
      },
    },
    action: {
      type: "radio",
      value: { value: 6, key: "graphically" },
      items: [
        { value: 6, key: "graphically" },
        { value: 20, key: "linearly" },
        { value: 26, key: "stickerly" },
        { value: 28, key: "excely" },
      ],
    },
    checkbox: {
      type: "checkbox",
      items: [
        { value: false, key: "isFrame" },
        { value: false, key: "isSash" },
        { value: false, key: "isSashDoor" },
        { value: false, key: "isMulion" },
        { value: false, key: "isGlazing" },
        { value: false, key: "isRokob" },
        { value: false, key: "isInterLock" },
        { value: false, key: "isConectorSash" },
        { value: false, key: "isOtherPop" },
        { value: false, key: "isOtherRail" },
        { value: false, key: "isPanel" },
        { value: false, key: "isProfileKomaki" },
        { value: false, key: "isNet" },
      ],
    },
  });

  const onChangeRadio = (name, key, value) => {
    setControls({ [name]: { value: value } });
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        Extra_OptimizeProfile: value,
        action: value.value,
      },
    });
  };

  const onChangeCheckbox = (e, name, index) => {
    const items = controls[name].items;
    items[index] = { ...items[index], value: e.currentTarget.checked };
    setControls({ [name]: { items: items } });
    const key = items[index].key;
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        [key]: e.currentTarget.checked,
      },
    });
  };

  const onChangeCheckbox_SelectAll = (e, name) => {
    let selected = {};
    setControls({
      [name]: {
        items: controls[name].items.map((inner) => {
          inner.value = true;
          selected[inner.key] = true;
          return inner;
        }),
      },
    });
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        ...selected,
      },
    });
  };

  const onClear = () => {
    setControls({
      action: {
        value: constructionResult.Extra_OptimizeProfile,
      },
    });
    setControls({
      branchLength: {
        value: constructionResult.lenBranch,
      },
    });
    setControls({
      checkbox: {
        items: [
          { value: constructionResult.isFrame, key: "isFrame" },
          { value: constructionResult.isSash, key: "isSash" },
          { value: constructionResult.isSashDoor, key: "isSashDoor" },
          { value: constructionResult.isMulion, key: "isMulion" },
          { value: constructionResult.isGlazing, key: "isGlazing" },
          { value: constructionResult.isRokob, key: "isRokob" },
          { value: constructionResult.isInterLock, key: "isInterLock" },
          { value: constructionResult.isConectorSash, key: "isConectorSash" },
          { value: constructionResult.isOtherPop, key: "isOtherPop" },
          { value: constructionResult.isOtherRail, key: "isOtherRail" },
          { value: constructionResult.isPanel, key: "isPanel" },
          { value: constructionResult.isProfileKomaki, key: "isProfileKomaki" },
          { value: constructionResult.isNet, key: "isNet" },
        ],
      },
    });
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        action: constructionResult.Extra_OptimizeProfile.value,
        lenBranch: +constructionResult.lenBranch,
        pageIndex: 170,
      },
    });
  };

  const setValue = (name, value) => {
    setControls({ [name]: { value: value } });
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        lenBranch: +value,
      },
    });
  };

  useEffect(() => {
    onClear();
  }, []);

  return (
    <>
      <Grid container className="pt-2">
        <Grid container spacing={2} className="mb-2">
          <Grid item lg={2} sm={4} xs={12}>
            <Input
              setValue={setValue.bind(this)}
              name="branchLength"
              value={controls.branchLength.value}
              validation={controls.branchLength.validation}
              label={<Translator id={"barLength"} />}
              type="text"
              endIcon={<Translator id="millimeter" />}
            />
          </Grid>
          <Grid item lg={10} sm={8} xs={12}>
            <MuiRadioGroup
              name="action"
              value={controls.action.value}
              items={controls.action.items}
              onChange={onChangeRadio}
              translate={true}
              className="horizontalRadio"
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <MuiCheckBoxGroup
            label={<Translator id={"selectProfile"} />}
            name="checkbox"
            value={controls.checkbox.value}
            items={controls.checkbox.items}
            onChange={onChangeCheckbox}
            translate={true}
            selectAllShow
            onSelectAll={onChangeCheckbox_SelectAll}
            className="horizontalCheckbox"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default OptimizeProfile;
